module.exports = __webpack_public_path__ + "img/complaint.d44a4024.png";